var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDydx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2C2C3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2113 7.42542L7.77905 24.9264H11.5961L24.092 7.42542H20.2113Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9937 7.42542L15.6516 12.5825L13.7423 15.3954L8.09717 7.42542H11.9937Z",
    fill: "url(#paint0_linear_8855_3161)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5808 24.9282L16.5251 19.2248L18.4328 16.4897L24.3979 24.9282H20.5808Z",
    fill: "url(#paint1_linear_8855_3161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8855_3161",
    x1: 10.7553,
    y1: 8.81505,
    x2: 15.8833,
    y2: 15.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8855_3161",
    x1: 21.5598,
    y1: 23.5241,
    x2: 15.2709,
    y2: 14.8964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6966FF",
    stopOpacity: 0.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/dydx.58bdfe9b784389e65358b2f794f90d71.svg";
export { ForwardRef as ReactComponent };